import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filter',
    pure: true,
})

@Injectable()
export class FiltersPipe implements PipeTransform {
    public transform(items: object[], field: string, value: string) {
        return (items && value) ? items.filter((item) => item[ field ] !== value && item[ field ] !== '') : [];
    }
}
